/**
 * Canonical names of the CustomEvents dispatched by `<use-vivian>` on the
 * host element. These are the wire-level contract consumed both by the
 * loader (dispatch side) and by optician sites (listener side).
 */
export const VIVIAN_EVENTS = {
    ready: "vivian:ready",
    sessionStarted: "vivian:session-started",
    frameSelected: "vivian:frame-selected",
    sessionEnded: "vivian:session-ended",
    consentChanged: "vivian:consent-changed",
};
//# sourceMappingURL=events.js.map